<template>
  <div>
    <el-table
      :data="resultList"
      border
      style="width: 100%; height: 300px;"
      :header-cell-style="{ background: '#f5f7fa' }"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '8px' }"
    >
      <el-table-column width="100" label="序号" type="index" align="center" />
      <el-table-column
        prop="code"
        label="状态"
        align="center"
        width="120"
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.code == 1">成功</el-tag>
          <el-tag type="danger" v-else>失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="message"
        label="描述详情"
        align="left"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span  v-if="scope.row.code == 1">{{ scope.row.message }}</span>
          <span class="red" v-else>{{ scope.row.message }}</span>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox } from "element-plus";
import { ref, reactive, toRefs, onMounted, h,computed } from "vue";
export default {
  name: "ResultList",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    resultList: Array,
  },
  setup(props, { emit }) {
    const data = reactive({
      
    });
    onMounted(() => {
      // console.log(resultList,'111222555')
    });


    return {
      ...toRefs(data)
    };
  },
};
</script>

<style scoped>
.red{
  color:red;
}

</style>